/* ═══════════════════════════════════════════════
   ALANNA — Card Add to Cart JS
   File: assets/alanna-card-atc.js

   FIXED:
   - AJAX Add to Cart
   - Black "Added!" success state
   - Refresh cart drawer
   - Refresh cart icon/count
   - Automatically open cart drawer
   - Refresh Best Seller recommendations
   ═══════════════════════════════════════════════ */


function alpCardATC(event, btn) {

  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }


  if (!btn) return;


  /* =========================================
     PREVENT DOUBLE CLICK
  ========================================== */

  if (btn.dataset.loading === 'true') {
    return;
  }


  var variantId =
    btn.dataset.variantId;


  if (!variantId) {
    console.error(
      'ALANNA ATC: Variant ID missing.'
    );

    return;
  }


  var originalHTML =
    btn.innerHTML;



  /* =========================================
     LOADING STATE
  ========================================== */

  btn.dataset.loading =
    'true';


  btn.disabled =
    true;


  btn.classList.add(
    'alp-card__atc-fixed--loading'
  );


  btn.classList.remove(
    'alp-card__atc-fixed--added'
  );


  btn.innerHTML = `
    <svg
      viewBox="0 0 24 24"
      style="
        stroke:currentColor;
        fill:none;
        stroke-width:2;
        stroke-linecap:round;
        width:15px;
        height:15px;
      "
    >
      <polyline points="23 4 23 10 17 10"></polyline>

      <path
        d="M20.49 15a9 9 0 1 1-.08-4.55"
      ></path>
    </svg>

    Adding...
  `;



  /* =========================================
     FORM DATA
  ========================================== */

  var formData =
    new FormData();


  formData.append(
    'id',
    variantId
  );


  formData.append(
    'quantity',
    '1'
  );


  /*
    IMPORTANT:

    Ask Shopify to return the updated
    Cart Drawer + Cart Icon in the SAME
    request.
  */

  formData.append(
    'sections',
    'cart-drawer,cart-icon-bubble'
  );


  formData.append(
    'sections_url',
    window.location.pathname
  );



  var cartAddURL =

    window.routes &&
    window.routes.cart_add_url

      ? window.routes.cart_add_url

      : '/cart/add.js';



  /* =========================================
     ADD TO CART
  ========================================== */

  fetch(
    cartAddURL,
    {

      method: 'POST',

      headers: {

        'X-Requested-With':
          'XMLHttpRequest',

        'Accept':
          'application/json'

      },

      body: formData

    }
  )


  .then(function(response) {

    return response.json()
      .then(function(data) {

        if (
          !response.ok ||
          data.status
        ) {

          throw new Error(
            data.description ||
            data.message ||
            'Could not add product to cart.'
          );

        }

        return data;

      });

  })


  .then(function(data) {


    /* =========================================
       SUCCESS BUTTON — BLACK
    ========================================== */

    btn.classList.remove(
      'alp-card__atc-fixed--loading'
    );


    btn.classList.add(
      'alp-card__atc-fixed--added'
    );


    /*
      Force BLACK even if old CSS
      tries to make --added green.
    */

    btn.style.setProperty(
      'background',
      '#000000',
      'important'
    );


    btn.style.setProperty(
      'background-color',
      '#000000',
      'important'
    );


    btn.style.setProperty(
      'border-color',
      '#000000',
      'important'
    );


    btn.style.setProperty(
      'color',
      '#ffffff',
      'important'
    );


    btn.innerHTML = `
      <svg
        viewBox="0 0 24 24"
        style="
          stroke:currentColor;
          fill:none;
          stroke-width:2.5;
          stroke-linecap:round;
          width:15px;
          height:15px;
        "
      >
        <polyline
          points="20 6 9 17 4 12"
        ></polyline>
      </svg>

      Added!
    `;



    /* =========================================
       GET CART DRAWER
    ========================================== */

    var cartDrawer =
      document.querySelector(
        'cart-drawer'
      );



    /* =========================================
       REFRESH + OPEN DRAWER
    ========================================== */

    if (
      cartDrawer &&
      typeof cartDrawer.renderContents ===
        'function'
    ) {

      /*
        Your custom cart-drawer.js already
        has renderContents().

        This updates:
        - Cart products
        - Cart totals
        - Cart count
        - Recommended products
        - Then opens the drawer
      */

      cartDrawer.renderContents(
        data
      );


      /*
        SAFETY FALLBACK:
        Ensure drawer opens even if
        renderContents doesn't open it.
      */

      setTimeout(
        function() {

          if (
            cartDrawer &&
            !cartDrawer.classList.contains(
              'active'
            ) &&
            typeof cartDrawer.open ===
              'function'
          ) {

            cartDrawer.open(
              btn
            );

          }

        },

        150

      );


    } else {


      /*
        FALLBACK:
        Manually refresh sections
        if cart-drawer.js has not
        initialized yet.
      */

      alannaUpdateCartSections(
        data
      );


      cartDrawer =
        document.querySelector(
          'cart-drawer'
        );


      if (cartDrawer) {

        cartDrawer.classList.remove(
          'is-empty'
        );


        if (
          typeof cartDrawer.open ===
            'function'
        ) {

          cartDrawer.open(
            btn
          );

        } else {

          cartDrawer.classList.add(
            'animate',
            'active'
          );


          document.body.classList.add(
            'overflow-hidden'
          );

        }

      }

    }



    /* =========================================
       RESET BUTTON AFTER 2.5 SEC
    ========================================== */

    setTimeout(
      function() {

        btn.classList.remove(
          'alp-card__atc-fixed--added'
        );


        btn.style.removeProperty(
          'background'
        );


        btn.style.removeProperty(
          'background-color'
        );


        btn.style.removeProperty(
          'border-color'
        );


        btn.style.removeProperty(
          'color'
        );


        btn.innerHTML =
          originalHTML;


        btn.disabled =
          false;


      },

      2500

    );


  })


  .catch(function(error) {


    console.error(
      'ALANNA Add To Cart Error:',
      error
    );


    /* =========================================
       RESTORE BUTTON
    ========================================== */

    btn.classList.remove(
      'alp-card__atc-fixed--loading'
    );


    btn.classList.remove(
      'alp-card__atc-fixed--added'
    );


    btn.style.removeProperty(
      'background'
    );


    btn.style.removeProperty(
      'background-color'
    );


    btn.style.removeProperty(
      'border-color'
    );


    btn.style.removeProperty(
      'color'
    );


    btn.innerHTML =
      originalHTML;


    btn.disabled =
      false;


    alert(
      error.message ||
      'Could not add to cart. Please try again.'
    );


  })


  .finally(function() {


    btn.dataset.loading =
      'false';


  });

}



/* ═══════════════════════════════════════════════
   FALLBACK SECTION REFRESH
   ═══════════════════════════════════════════════ */

function alannaUpdateCartSections(data) {

  if (
    !data ||
    !data.sections
  ) {

    return;

  }


  var parser =
    new DOMParser();



  /* =========================================
     CART DRAWER
  ========================================== */

  if (
    data.sections[
      'cart-drawer'
    ]
  ) {

    var drawerDocument =
      parser.parseFromString(

        data.sections[
          'cart-drawer'
        ],

        'text/html'

      );


    var incomingDrawer =
      drawerDocument.querySelector(
        '#CartDrawer'
      );


    var currentDrawer =
      document.querySelector(
        '#CartDrawer'
      );


    if (
      incomingDrawer &&
      currentDrawer
    ) {

      currentDrawer.innerHTML =
        incomingDrawer.innerHTML;

    }

  }



  /* =========================================
     HEADER CART ICON
  ========================================== */

  if (
    data.sections[
      'cart-icon-bubble'
    ]
  ) {

    var iconDocument =
      parser.parseFromString(

        data.sections[
          'cart-icon-bubble'
        ],

        'text/html'

      );


    var incomingIcon =
      iconDocument.querySelector(
        '#cart-icon-bubble'
      );


    var currentIcon =
      document.querySelector(
        '#cart-icon-bubble'
      );


    if (
      incomingIcon &&
      currentIcon
    ) {

      currentIcon.innerHTML =
        incomingIcon.innerHTML;

    }

  }

}